<template>
  <div class="main-layout">
    <div class="container">
      <router-view/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MainLayout"
  }
</script>

<style lang="scss">
  @import "MainLayout";
</style>
